var _filter, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceAlpha"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "1 0"
  })), /*#__PURE__*/React.createElement("feConvolveMatrix", {
    in: "SourceAlpha",
    result: "outline",
    kernelMatrix: "0 -1 0 -1 4 -1 0 -1 0"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "outline",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0,0,0,0.55)"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "offsetblur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offsetblur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.36153 1.34066C6.15774 0.203231 7.84226 0.203229 8.63846 1.34066L14 9L-4.37114e-07 9L5.36153 1.34066Z",
    fill: "#F3F2F7",
    filter: "url(#drop-shadow)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.95a0aaa7cad44bc4a993b9cd84cdd051.svg";
export { ForwardRef as ReactComponent };